import * as t from "react";
import r from "../lib/IconBase.es.js";
import n from "../defs/TextAlignRight.es.js";
const e = t.forwardRef((o, i) => /* @__PURE__ */ t.createElement(r, { ref: i, ...o, weights: n }));
e.displayName = "TextAlignRightIcon";
const c = e;
export {
  c as TextAlignRight,
  e as TextAlignRightIcon
};
